import { useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { mathpidLogAPICall } from "../../../../redux/logData";
import useAnswer from "../../../../hooks/answeringQuestions/useAnswer";
import useAmplitude from "../../../../hooks/useAmplitude";
import { appsflyer, appsflyerEventName } from "../../../../utils/appsflyer";

const Logger = ( props ) => {

  const isUnmount = useRef( false );
  const answer = useRef();
  const completeCode = useRef();
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setLog = payload => { dispatch( mathpidLogAPICall( payload ) ) };

  const { convertAnswer } = useAnswer();
  const { setAmplitudeLog } = useAmplitude();

  useEffect( () => {
    setLog( {
      verbId : TYPE.LOG.VERB.ATTEMPTED,
      objectId : TYPE.LOG.OBJECT.ASSESSMENT,
      idName : 'stgCd',
      idValue : 'AITEST_0_0',
    } );
    setAmplitudeLog({ eventCategory: 'test', eventName: '진단test 시작', isHackleSend: true });
    appsflyer({
      eventName: appsflyerEventName.test_start,
      eventParams: null
    });
    return () => {
      isUnmount.current = true;
    };
  }, [] );

  useEffect( () => {
    if ( answeringQuestions.data.qstCd ) {
      const data = {
        objectId : TYPE.LOG.OBJECT.QUESTION,
        idName : 'qstCd',
        idValue : answeringQuestions.data.qstCd
      };
      setLog( { ...data, verbId : TYPE.LOG.VERB.OPENED } );

      return () => {
        switch ( true ) {
          case ! isUnmount.current :
          case !! ( isUnmount.current && completeCode.current ) :
            setLog( {
              ...data,
              verbId : TYPE.LOG.VERB.ANSWERED,
              contentInfo : { answer : answer.current }
            } );
            setAmplitudeLog({
              eventName: {
                name: '진단문항풀이 완료',
                event: {
                  "소주제이름": answeringQuestions.data.stepNm,
                  "소주제코드": answeringQuestions.data.stgCd,
                  "문항코드": answeringQuestions.data.qstCd,
                  "커리큘럼그룹": answeringQuestions.data.thmaNm,
                  "커리큘럼명": answeringQuestions.data.stepNm,
                }
              }
            })
            break;
        }
      };
    }
  }, [ answeringQuestions.data.qstCd ] );

  useEffect( () => {
    answer.current = convertAnswer( answeringQuestions.answer );
    
  }, [ answeringQuestions.answer ] );

  useEffect( () => {
    completeCode.current = answeringQuestions.resultData.prgsCd;
  }, [ answeringQuestions.resultData.prgsCd ] );

  useEffect( () => {
    return () => {
      setLog( {
        verbId : completeCode.current ? TYPE.LOG.VERB.COMPLETED : TYPE.LOG.VERB.TERMINATED,
        objectId : TYPE.LOG.OBJECT.ASSESSMENT,
        idName : 'stgCd',
        idValue : 'AITEST_0_0'
      } );

    };
  }, [] );

  return props.children || null;

};

export default Logger;
